/* eslint-disable no-unused-vars */
import React from 'react';

import PropTypes from 'prop-types';

import {
  useRouteMatch,
  Switch,
  Route,
} from 'react-router-dom';
import { useSelector } from 'react-redux';

import OnboardingProcessing from '../Onboarding/OnboardingProcessing';
import OnboardingCreateEdit from './OnboardingCreateEdit';

const OnboardingRouting = ({ userId, theme }) => {
  const { url } = useRouteMatch();

  const { onbording } = useSelector((state) => state.accountReducer);

  return (
    <Switch>
      <Route path={`${url}/edit/:onboardingId/`}>
        <OnboardingCreateEdit theme={theme} />
      </Route>
      <Route path={`${url}/processing`}>
        <OnboardingProcessing
          userId={userId}
          meeningId={onbording?.id}
          status={onbording?.status}
          url={url}
        />
      </Route>
    </Switch>
  );
};

export default OnboardingRouting;

OnboardingRouting.propTypes = {
  userId: PropTypes.string,
  theme: PropTypes.string,
};
